module.exports = __webpack_public_path__ + "static/media/gps_tracking.d574a405.svg";